export default {
    data() {
        return {
            ranks: 
            [
                {
                    "numerical_value": 18,
                    "name": "Klipsu I",
                    "image_url": require("@/assets/ranks/Klipsu-I.png")
                },
                {
                    "numerical_value": 17,
                    "name": "Klipsu II",
                    "image_url": require("@/assets/ranks/Klipsu-II.png")
                },
                {
                    "numerical_value": 16,
                    "name": "Klipsu III",
                    "image_url": require("@/assets/ranks/Klipsu-III.png")
                },
                {
                    "numerical_value": 15,
                    "name": "Klipsu IV",
                    "image_url": require("@/assets/ranks/Klipsu-IV.png")
                },
                {
                    "numerical_value": 14,
                    "name": "Klipsu Mestari",
                    "image_url": require("@/assets/ranks/Klipsu-Mestari.png")
                },
                {
                    "numerical_value": 13,
                    "name": "Klipsu Eliitti Mestari",
                    "image_url": require("@/assets/ranks/Klipsu-Eliitti-Mestari.png")
                },
                {
                    "numerical_value": 12,
                    "name": "Kultapossu I",
                    "image_url": require("@/assets/ranks/Kultapossu-I.png")
                },
                {
                    "numerical_value": 11,
                    "name": "Kultapossu II",
                    "image_url": require("@/assets/ranks/Kultapossu-II.png")
                },
                {
                    "numerical_value": 10,
                    "name": "Kultapossu III",
                    "image_url": require("@/assets/ranks/Kultapossu-III.png")
                },
                {
                    "numerical_value": 9,
                    "name": "Kultapossu Mestari",
                    "image_url": require("@/assets/ranks/Kultapossu-Mestari.png")
                },
                {
                    "numerical_value": 8,
                    "name": "Mestari Heittäjä I",
                    "image_url": require("@/assets/ranks/Mestari-Heittäjä-I.png")
                },
                {
                    "numerical_value": 7,
                    "name": "Mestari Heittäjä II",
                    "image_url": require("@/assets/ranks/Mestari-Heittäjä-II.png")
                },
                {
                    "numerical_value": 6,
                    "name": "Mestari Heittäjä Eliitti",
                    "image_url": require("@/assets/ranks/Mestari-Heittäjä-Eliitti.png")
                },
                {
                    "numerical_value": 5,
                    "name": "Arvostettu Jallu Mestari",
                    "image_url": require("@/assets/ranks/Arvostettu-Jallu-Mestari.png")
                },
                {
                    "numerical_value": 4,
                    "name": "Legendaarinen Nalle",
                    "image_url": require("@/assets/ranks/Legendaarinen-Nalle.png")
                },
                {
                    "numerical_value": 3,
                    "name": "Legendaarinen Nalle Mestari",
                    "image_url": require("@/assets/ranks/Legendaarinen-Nalle-Mestari.png")
                },
                {
                    "numerical_value": 2,
                    "name": "Korkein Ykkösluokan Mestari",
                    "image_url": require("@/assets/ranks/Korkein-Ykkösluokan-Mestari.png")
                },
                {
                    "numerical_value": 1,
                    "name": "Urheileva Alkoholisti",
                    "image_url": require("@/assets/ranks/Urheileva-Alkoholisti.png")
                }
            ]
        }
    }
};